// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}

.success-checkmark__check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
}

.success-checkmark__icon-line {
  height: 5px;
  background-color: #ffffff;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}
.success-checkmark__icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 1.25s;
}
.success-checkmark__icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 1.25s;
}

.success-checkmark__circle-svg,
.success-checkmark__mark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.success-checkmark__mark {
  width: 140px;
  height: 140px;
  border-radius: 100px;
  opacity: 0;
  animation: fadeIn 0.75s linear forwards;
  animation-delay: 1s;
}

.success-checkmark__circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: stroke 2s ease-out forwards;
}

@keyframes stroke {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BlockingWindow/doneWindow/doneWindow.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AACF;AACE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,8BAAA;AACJ;AAEE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;AAAJ;;AAIA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,uCAAA;EACA,mBAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,sCAAA;AADF;;AAIA;EACE;IACE,oBAAA;EADF;AACF;AAIA;EACE;IACE,UAAA;EAFF;AACF;AAKA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;EAHF;EAKA;IACE,QAAA;IACA,SAAA;IACA,SAAA;EAHF;EAKA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EAHF;EAKA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EAHF;EAKA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EAHF;AACF;AAMA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;EAJF;EAMA;IACE,QAAA;IACA,WAAA;IACA,SAAA;EAJF;EAMA;IACE,WAAA;IACA,QAAA;IACA,SAAA;EAJF;EAMA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EAJF;AACF","sourcesContent":[".success-checkmark {\n  width: 80px;\n  height: 115px;\n  margin: 0 auto;\n}\n\n.success-checkmark__check-icon {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  border-radius: 50%;\n  box-sizing: content-box;\n}\n\n.success-checkmark__icon-line {\n  height: 5px;\n  background-color: #ffffff;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n\n  &.line-tip {\n    top: 46px;\n    left: 14px;\n    width: 25px;\n    transform: rotate(45deg);\n    animation: icon-line-tip 1.25s;\n  }\n\n  &.line-long {\n    top: 38px;\n    right: 8px;\n    width: 47px;\n    transform: rotate(-45deg);\n    animation: icon-line-long 1.25s;\n  }\n}\n\n.success-checkmark__circle-svg,\n.success-checkmark__mark {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n}\n\n.success-checkmark__mark {\n  width: 140px;\n  height: 140px;\n  border-radius: 100px;\n  opacity: 0;\n  animation: fadeIn 0.75s linear forwards;\n  animation-delay: 1s;\n}\n\n.success-checkmark__circle {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: stroke 2s ease-out forwards;\n}\n\n@keyframes stroke {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes icon-line-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@keyframes icon-line-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
